import theme from 'tailwindcss/defaultTheme';
import type { Config } from 'tailwindcss';
import { colors, borderRadius, spacing, dropShadow, screens } from './src/style/theme';

const config: Config = {
	theme: {
		...theme,
		screens,
		fontSize: {
			xs: '10px',
			sm: '12px',
			md: '14px',
			lg: '16px',
			xl: '18px',
			'2xl': '20px',
			'cta-lg': [
				'16px',
				{
					fontWeight: 600,
					lineHeight: '22px',
				},
			],
			'cta-md': [
				'14px',
				{
					fontWeight: 600,
					lineHeight: '20px',
				},
			],
			'cta-sm': [
				'12px',
				{
					fontWeight: 600,
					lineHeight: '18px',
				},
			],
		},
		extend: {
			extend: {
				fontFamily: {
					sans: ['var(--font-anuphan)'],
					mono: ['var(--font-roboto-mono)'],
				},
			},
			backgroundImage: {
				'gradient-radial': 'radial-gradient(var(--tw-gradient-stops))',
				'gradient-conic': 'conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))',
			},
			colors,
			spacing,
			borderRadius,
			dropShadow,
			animation: {
				fadeIn: 'fade 250ms ease-in-out',
				fadePulse: 'fadePulse 250ms ease-in-out',
			},
			keyframes: {
				fade: {
					'0%': { opacity: '0' },
					'100%': { opacity: '1' },
				},
				fadePulse: {
					'0%': { opacity: '1' },
					'50%': { opacity: '0.7' },
					'100%': { opacity: '1' },
				},
			},
		},
		fontFamily: {
			anuphan: ['var(--font-anuphan)'],
			darker_grotesque: 'var(--font-darker-grotesque)',
		},
	},
	plugins: [require('tailwindcss-animate')],
	content: [
		'./src/pages/**/*.{js,ts,jsx,tsx,mdx}',
		'./src/components/**/*.{js,ts,jsx,tsx,mdx}',
		'./src/app/**/*.{js,ts,jsx,tsx,mdx}',
		'./src/**/*.{js,ts,jsx,tsx,mdx}',
	],
};

export default config;
